export default "__VITE_ASSET__HsBiqGSd__"